import { useState } from "react";
import { db } from "../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";

const PostInternship = () => {
  const { user, role } = useAuth();
  const [success, setSuccess] = useState(false);
  const [internship, setInternship] = useState({
    title: "",
    company: "",
    location: "",
    applyLink: "",
    stipend: "",
    duration: "",
    deadline: "",
    paid: false,
    remote: false,
  });

  const handleChange = (e) => {
    const value =
      e.target.type === "checkbox"
        ? e.target.checked
        : e.target.type === "number"
        ? Number(e.target.value)
        : e.target.value;
    setInternship({ ...internship, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (role !== "admin") return;

    try {
      await addDoc(collection(db, "internships"), {
        ...internship,
        stipend: Number(internship.stipend),
        duration: Number(internship.duration),
        postedBy: user.email,
        source: "Manual",
        timestamp: serverTimestamp(),
      });
      setSuccess(true);
      setInternship({
        title: "", company: "", location: "", applyLink: "",
        stipend: "", duration: "", deadline: "", paid: false, remote: false,
      });
      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      console.error("Error posting internship:", error);
    }
  };

  if (role !== "admin") {
    return <p className="text-center text-red-600 py-4">Access denied. Admin only.</p>;
  }

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Add New Internship</h2>

      {success && (
        <div className="mb-4 flex items-center gap-2 p-3 bg-green-50 border border-green-100 rounded-lg">
          <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-sm text-green-700">Internship posted successfully!</span>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
            <input name="title" value={internship.title} onChange={handleChange} required className="input-field" placeholder="e.g. Frontend Developer Intern" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
            <input name="company" value={internship.company} onChange={handleChange} required className="input-field" placeholder="e.g. Google" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
            <input name="location" value={internship.location} onChange={handleChange} required className="input-field" placeholder="e.g. Bangalore, India" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Apply Link</label>
            <input name="applyLink" value={internship.applyLink} onChange={handleChange} required className="input-field" placeholder="https://..." />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Stipend (per month)</label>
            <input type="number" name="stipend" value={internship.stipend} onChange={handleChange} required className="input-field" placeholder="e.g. 25000" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Duration (months)</label>
            <input type="number" name="duration" value={internship.duration} onChange={handleChange} required min="1" max="12" className="input-field" placeholder="e.g. 3" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Deadline</label>
            <input type="date" name="deadline" value={internship.deadline} onChange={handleChange} className="input-field" />
          </div>
        </div>

        <div className="flex items-center gap-6 pt-2">
          <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input type="checkbox" name="paid" checked={internship.paid} onChange={handleChange} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
            Paid
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input type="checkbox" name="remote" checked={internship.remote} onChange={handleChange} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
            Remote
          </label>
        </div>

        <button type="submit" className="button btn-primary">
          Post Internship
        </button>
      </form>
    </div>
  );
};

export default PostInternship;
